const API_PREFIX = 'learn'

export const urls = {
	profile: {
		endpoint: `${API_PREFIX}/user`,
		type: 'GET',
	},
	courses: {
		endpoint: `${API_PREFIX}/courses/`,
		type: 'GET',
	},
	courseAutocomplete: {
		endpoint: `${API_PREFIX}/courses/search/`,
		type: 'GET',
	},
	tags: {
		endpoint: `${API_PREFIX}/tags/`,
		type: 'GET',
	},
	course: {
		endpoint: `${API_PREFIX}/course/`,
		type: 'GET',
	},
	topic: {
		endpoint: `${API_PREFIX}/course/`,
		type: 'GET',
	},
	updateTopicStatus: {
		endpoint: `${API_PREFIX}/course/`,
		type: 'PATCH',
	},
	heartBeat: {
		endpoint: `${API_PREFIX}/account/hb/`,
		type: 'GET',
	},
	userInfo: {
		endpoint: `${API_PREFIX}/userinfo/`,
		type: 'GET',
	},
	login: {
		endpoint: `${API_PREFIX}/account/login/`,
		type: 'POST',
	},
	logout: {
		endpoint: `${API_PREFIX}/account/logout/`,
		type: 'POST',
	},
	repository: {
		endpoint: `${API_PREFIX}/course/`,
		type: 'GET',
	},
	openIdClient: {
		endpoint: `${API_PREFIX}/ocid/`,
		type: 'GET',
	},
	createSandbox: {
		endpoint: `${API_PREFIX}/sandbox/`,
		type: 'POST',
	},
	getSandboxStatus: {
		endpoint: `${API_PREFIX}/sandbox/`,
		type: 'GET',
	},
	deleteSandbox: {
		endpoint: `${API_PREFIX}/sandbox/`,
		type: 'DELETE',
	},
	userCustomisationGet: {
		endpoint: `${API_PREFIX}/user-customisation/`,
		type: 'GET',
	},
	userCustomisationCreate: {
		endpoint: `${API_PREFIX}/user-customisation/`,
		type: 'POST',
	},
	userCustomisationUpdate: {
		endpoint: `${API_PREFIX}/user-customisation/`,
		type: 'PATCH',
	},
	learningPathGet: {
		endpoint: `${API_PREFIX}/learning-path/`,
		type: 'GET',
	},
	learningPathCreate: {
		endpoint: `${API_PREFIX}/learning-path/`,
		type: 'POST',
	},
	userLearningPathGet: {
		endpoint: `${API_PREFIX}/user-learning-path/`,
		type: 'GET',
	},
	learningPathTopic: {
		endpoint: `${API_PREFIX}/topic/`,
		type: 'GET',
	},
	// Play
	challenge: {
		endpoint: `play/challenge/`,
		type: 'GET',
	},
	games: {
		endpoint: `play/games/`,
		type: 'GET',
	},
	gameChallenges: {
		endpoint: `play/game/`,
		type: 'GET',
	},
}

export default urls
